import { TProducts } from 'modules/products/context';
import { ConsigneeOrganType } from 'modules/products/pages/ApplicationRequest/ConsignedStep/interfaces';
import { IList } from 'modules/products/services/hooks/interfaces';

export enum EProductSubType {
  REFINANCING = 'REFINANCING',
}

export const isProductVisible = (product: TProducts): boolean => {
  return !(
    product.sub_type === EProductSubType.REFINANCING &&
    product.organ_type === ConsigneeOrganType.CT
  );
};

export const filterVisibleProducts = <T extends TProducts>(
  products: T[],
): T[] => {
  return products.filter(isProductVisible);
};

export const filterVisibleProductsList = (
  list: IList<TProducts>,
): IList<TProducts> => {
  const visibleProducts = filterVisibleProducts(list.content);

  return {
    ...list,
    content: visibleProducts,
    total_elements: visibleProducts.length,
  };
};

export type TApplicationWithProductData = {
  productData?: TProducts;
};

export const isApplicationWithProductVisible = (
  application: TApplicationWithProductData,
): boolean => {
  if (!application.productData) {
    return true;
  }

  return isProductVisible(application.productData);
};

export const filterVisibleApplications = <
  T extends TApplicationWithProductData,
>(
  applications: T[],
): T[] => {
  return applications.filter(isApplicationWithProductVisible);
};
